<template>
    <div>
        <h5 class="text-uppercase font-weight-bold ">
            Your organization{{ userOrganizations && userOrganizations.length > 1 ? "s" : "" }}
        </h5>

        <div class="position-relative">
            <div
                class="d-flex bg-white list-item p-2"
                v-for="organization in userOrganizations"
                :key="organization.address1"
            >
                <div>
                    <img class="client-image" :src="organization.logo_url" alt="Logo" />
                </div>
                <div class="ml-3 d-block">
                    <h4 class="p-0 m-0">
                        <em class="text-capitalize">{{ organization.name }}</em>
                    </h4>
                    <p class="p-0 m-0 text-capitalize">
                        {{ organization.address1 }} {{ organization.address2 }}
                    </p>
                    <p class="p-0 m-0">
                        <em
                            >Last Updated:
                            {{
                                organization.created_at
                                    ? moment(organization.created_at).format("MM/DD/YYYY")
                                    : "No info"
                            }}</em
                        >
                    </p>
                    <p class="p-0 m-0">
                        <b>{{ helpers.formatPhone(organization.primary_phone) }}</b>
                    </p>
                    <p class="p-0 m-0" style="color:dodgerblue">{{ user.email || "No email" }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { helpers } from "../../plugins/helpers";

export default {
    name: "OrganizationListWidget",
    props: ["user", "userOrganizations"],
    data() {
        return {
            helpers,
        };
    },
    created() {},
};
</script>

<style scoped lang="scss">
.client-image {
    width: 64px;
    height: 64px;
}

.details {
    > p {
        font-size: 80%;
    }
}
.list-item {
    border: solid 1px #bfbfbf;
}
.list-item:not(:first-child) {
    border-top: none;
}
.overlay {
    top: 0;
    left: 0;
    min-width: 100%;
    min-height: 100%;
    z-index: 2;
    background-color: rgba(255, 255, 255, 0.7);
}

.details {
}
</style>
